import './public-path'
import Vue from "vue";

//引入字体
// import './assets/otf/font.css';
//按需引入and-design UI组件
import {
    Table,
    Button,
    Layout,
    Icon,
    Drawer,
    Radio,
    Menu,
    Modal,
    Form,
    message
} from "ant-design-vue";

import * as Antd from "ant-design-vue/es";
import "ant-design-vue/dist/antd.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import echarts from "echarts";
import Storage from 'vue-ls';
import "./styles/index.less"
import "./styles/variable.css"
import "./styles/main.less"
import { initStyleChange } from './utils/styleChange'


import { Chart } from '@antv/g2';
import Cookies from "js-cookie";
import i18n from './lang'
import Ellipsis from './views/workflow/components/common/Ellipsis'
import WDialog from './views/workflow/components/common/WDialog'
import Tip from './views/workflow/components/common/Tip'

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import TDesign from 'tdesign-vue';
// 引入组件库的少量全局样式变量
import 'tdesign-vue/es/style/index.css';
import VEmojiPicker from 'v-emoji-picker'
import service from './interface/basic/request';
import './styles/global.less'
import datetimeMixin from './mixins/datetimeMixin'
import msalMixin from './mixins/msalMixin'
Vue.mixin(msalMixin)
Vue.mixin(datetimeMixin)
Vue.use(Ellipsis);
Vue.use(WDialog);
Vue.use(Tip);
Vue.prototype.$antv = Chart;
Vue.prototype.$bus = new Vue();
Vue.prototype.$echarts = echarts;
Vue.prototype.$ajax = service;

Vue.use(TDesign);
Vue.use(VEmojiPicker);
Vue.use(ViewUI);
Vue.prototype.axios = service;
Vue.config.productionTip = false

message.config({
    maxCount: 1,
  });
  
Vue.prototype.$isNotEmpty = function(obj){
    return (obj !== undefined && obj !== null && obj !== '' && obj !== 'null')
}


Vue.prototype.$getDefalut = function(obj, key, df){
    return (obj === undefined || key === undefined || !this.$isNotEmpty(obj[key])) ? df : obj[key];
}

Vue.prototype.$deepCopy = function (obj){return JSON.parse(JSON.stringify(obj))}
const options={
    namespace:'',
    name:'ls',
    storage:'session'
}
Vue.config.productionTip = false;
Vue.use(Storage,options)
Vue.use(Button);
Vue.use(Layout);
Vue.use(Icon);
Vue.use(Drawer);
Vue.use(Radio);
Vue.use(Menu);
Vue.use(Table);
Vue.use(Modal);
Vue.use(Form);
Vue.use(Antd);
Vue.prototype.$modal = Modal;
// Vue.use(Chart);
import('./styles/atom.css')
// const loginType = localStorage.getItem('style') || 'atom'
// if(loginType === 'atom') {
//     import('./styles/atom.css')
// } else if(loginType === 'yoplait') {
//     import('./styles/atom.css')
// } else {
//     import('./styles/mcd.css')
// }
Vue.mixin({
    created() {
        const mainColor = localStorage.getItem('mainColor')
        const fontColor = localStorage.getItem('fontColor')
        if(mainColor && fontColor) {
            initStyleChange()
        }
    }
})

if(Cookies.get("userDate")){
    let userdate = JSON.parse(Cookies.get("userDate"));
    localStorage.setItem("userName",userdate.user_name);
    localStorage.setItem("userId",userdate.user_id);
    localStorage.setItem("token",userdate.token);
    localStorage.setItem("menu",JSON.stringify(userdate.menu));
    localStorage.setItem("userInfo",JSON.stringify(userdate.user_info));
}else{
}
Vue.prototype.$globalSize = 'large';
// 挂载在Vue对象上
Plugin.install = function(Vue, options) {
    Vue.axios = service;
    window.axios = service;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return service;
            }
        },
        $axios: {
            get() {
                return service;
            }
        },
    });
};

Vue.use(Plugin);

Vue.config.productionTip = false
new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount("#app");

